import React from 'react';
import MainEventBus from '../../utils/evbus';
import styled from 'styled-components';
import CustomToast, { TOAST_TIMER, Notification } from './CustomToast';
import { useAppSelector } from '../../store';
import { selectCurrentNotification } from '../../store/slices/notifications';

const NotificationElementDiv = styled.div({
  position: 'fixed',
  bottom: '10px',
  left: '10px',
  zIndex: '9999',
});
const Notifications = () => {
  const [notifications, setNotifications] = React.useState<Notification[]>([]);

  const currentManagerNotification = useAppSelector(selectCurrentNotification) as any;
  const isModalActive = currentManagerNotification?.type === 'modal';
  const isSuppressed = !!currentManagerNotification?.suppressToast;
  const suppressLegacyToasts = isModalActive || isSuppressed;

  React.useEffect(() => {
    if (suppressLegacyToasts && notifications.length) {
      setNotifications([]);
    }
  }, [suppressLegacyToasts]);

  const removeNotification = () => {
    setNotifications((v) => {
      const newNotifications = [...v];
      // remove notification from the end of the array
      newNotifications.pop();
      return newNotifications;
    });
  };

  const processNotification = (data: Notification) => {

    if (suppressLegacyToasts) return;

    setNotifications((v) => {
      const newNotifications = [...v];

      // set type to info by default
      if (!data.type) {
        data.type = 'info';
      }

      // set progress bar to true by default
      if (typeof data.progressBar === 'undefined') {
        data.progressBar = true;
      }

      // set icon to true by default
      if (typeof data.icon === 'undefined') {
        data.icon = true;
      }

      data.id = Math.random().toString(36).substr(2, 9);
      // push new notification to the beginning of the array
      newNotifications.unshift(data);
      // remove notification after duration
      setTimeout(() => {
        removeNotification();
      }, data.duration ?? TOAST_TIMER);
      return newNotifications;
    });
  };

  React.useEffect(() => {
    MainEventBus.on('NOTIFICATION', processNotification);
    return () => {
      MainEventBus.remove('NOTIFICATION', processNotification);
    };
  }, [suppressLegacyToasts]);

  // Do not render existing legacy toasts while a modal is active
  if (suppressLegacyToasts) {
    return null;
  }

  return (
    <NotificationElementDiv>
      {notifications.map((notification) => {
        return <CustomToast key={notification.id} notification={notification} />;
      })}
    </NotificationElementDiv>
  );
};

export default Notifications;
